import { ErrorFallback } from '../components';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export function ProvideErrorBoundary({ children }: React.PropsWithChildren<{}>) {
    return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
}
